import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-gcap-list',
  templateUrl: './gcap-list.component.html',
  styleUrls: ['./gcap-list.component.scss'],
})
export class GCAPListComponent {
  @Output() readonly linkClick = new EventEmitter<boolean>();

  /**
   * Emit link click event to parent
   */
  onLinkClick(): void {
    console.log('GCAP Link clicked');
    this.linkClick.emit(true);
  }
}
